export default __webpack_public_path__ + "static/media/fad-filter-notch.5fe9d895.svg";